import React, { useContext, useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ToolTipWrapper from '../Tooltip/ToolTipWrapper';
import {
    Route,
    Navigate,
    NavLink,
    Routes
  } from "react-router";

import SearchAndFilter from './SearchAndFilter'
import BatchManagementTable from './BatchManagementTable';
import ArchivedManagementTable from './ArchivedManagementTable';
import EventsManagementTable from './EventsManagmentTable';
import FileUpload from './FileUpload';

import { LockerManagementContext } from '@/context/LockerManagmentContext';
import { LockerManagementFileUploadContext } from '@/context/LockerManagementFileUploadContext';
import Toast, { ToastMessageType } from '../global/ToastNotification';
import { LockerContextRefreshType as Table } from  '@/interfaces/LockerManagement'
import useBatchIngestNotificaitons from  '@/components/hooks/Locker/useBatchIngest';


const LockerManagement = ({orgId}:{orgId: number}) => { 

    const [showToast, setShowToast] = useState<boolean>();
    const [toastProps, setToastProps] = useState<{messageType?: ToastMessageType, message?: JSX.Element}>({message: undefined, messageType: undefined});
    const { searchAndFilter, searchParams, filterOptions, isLoading, currentTable } = useContext(LockerManagementContext)
    const { files, batchName, selectedGroups, selectedUsers } = useContext(LockerManagementFileUploadContext);

    const hasUploadInProgress = (files.length || batchName || selectedGroups.length || selectedUsers.length)

    function setToast(messageType: ToastMessageType, message: JSX.Element){
        setShowToast(true);
        setToastProps({messageType, message})
    }

    useBatchIngestNotificaitons({orgId, table: currentTable , refreshTimeout: currentTable === Table.EVENTS ? 2000 : 5000});
    
    return (
        <main id="locker-management-main">
            <Toast show={showToast} closeToast={() => setShowToast(false)} messageType={toastProps?.messageType}>
                {toastProps?.message}
            </Toast>
            
                <div className="locker-management-header">
                    <h1>Locker Management</h1>
                    <ToolTipWrapper id="highlight-tooltip-locker-management" className="tracks-side-tooltip">
                        <ReactTooltip id="highlight-tooltip-locker-management" place="top" className='thrive-tooltip' delayHide={1000} >
                            <span>View and manage Locker files and Locker events for your organisation</span>
                        </ReactTooltip>
                    </ToolTipWrapper>
                </div>
                <nav className="locker-management-nav">
                    <ul  className="locker-management-nav-list">
                        <li><NavLink to="/LockerFiles" className={({isActive}) => `locker-management-link ${isActive ? 'selected' : ''}`}>Locker Files</NavLink></li>
                        <li><NavLink to="/ArchivedFiles" className={({isActive}) => `locker-management-link ${isActive ? 'selected' : ''}`}>Archived Files</NavLink></li>
                        <li style={{position:'relative'}}>
                            <NavLink to="/FileUpload" className={({isActive}) => `locker-management-link ${isActive ? 'selected' : ''}`}>File Upload</NavLink>
                            {!!hasUploadInProgress && <div className={'unsaved-changes'} />}
                        </li>
                        <li><NavLink to="/EventOverview" className={({isActive}) => `locker-management-link ${isActive ? 'selected' : ''}`}>Event Overview</NavLink></li>
                    </ul>
                </nav>
                <Routes>
                    <Route path="/LockerFiles" element={
                        <>
                            <SearchAndFilter
                                key="Files"
                                prevValues={searchParams[Table.BATCHES]}
                                placeholder="Search by batch or file name"
                                onSearchSubmit={({searchTerm, dropdownValue}) => {searchAndFilter(Table.BATCHES, {searchTerm, filter: dropdownValue})}}
                                ddOptions={filterOptions.batches ? [{value: '', label: 'All Dates'}, ...filterOptions.batches] : []}
                                isLoading={isLoading}
                                ddPlaceholder='All Dates'
                            />
                            <BatchManagementTable {...{setToast}}/>
                        </>
                    }
                    />
                       
                    
                    <Route path="/ArchivedFiles" element={
                         <>
                         <SearchAndFilter
                             key="Archived"
                             prevValues={searchParams[Table.ARCHIVE]}
                             placeholder="Search by batch or file name"
                             onSearchSubmit={({searchTerm, dropdownValue}) => {searchAndFilter(Table.ARCHIVE, {searchTerm, filter: dropdownValue})}}
                             ddOptions={filterOptions.archive ? [{value: '', label: 'All Dates'}, ...filterOptions.archive] : []}
                             isLoading={isLoading}
                             ddPlaceholder='All Dates'
                         />
                         <ArchivedManagementTable {...{setToast}}/>
                     </>
                    } />
                       
                    <Route path="/FileUpload" element={<FileUpload {...{setToast}}/>} />
        
    
                    <Route path="/EventOverview" element={
                        <>
                            <SearchAndFilter
                                key="Event"
                                className='event'
                                prevValues={searchParams[Table.EVENTS]}
                                placeholder="Search by batch or file name"
                                onSearchSubmit={({searchTerm, dropdownValue}) => searchAndFilter(Table.EVENTS, {searchTerm, filter: dropdownValue})}
                                ddOptions={filterOptions.events ? filterOptions.events : []}
                                isLoading={isLoading}
                                ddPlaceholder='All Statuses'
                            />
                            <EventsManagementTable {...{setToast, orgId}}/>
                        </>
                    } />
                        
                   
                    <Route
                        path="/"
                        element={<Navigate to="/LockerFiles"/>}
                    />
                    
                </Routes>
        </main>
    )
}

export default LockerManagement